import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-file-alert',
  templateUrl: './file-alert.component.html',
  styleUrls: ['./file-alert.component.scss']
})
export class FileAlertComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<FileAlertComponent>,) { }

  ngOnInit(): void {
  }
}
